import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    container: {
        marginBottom: 16,
    },
    datesContainer: {
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: 8,
    },
    progressContainer: {
        height: 4,
        borderRadius: 2.5,
    },
    legendContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: 16,
    },
    usedLabelContainer: {
        borderLeftWidth: 3,
        height: 18,
        paddingLeft: 4,
    },
    totalLabelContainer: {
        borderLeftWidth: 3,
        height: 18,
        paddingLeft: 4,
        marginLeft: 16,
    },
    percentageIndicator: {
        height: 4,
        marginTop: 0,
        alignItems: 'flex-start',
    },
    text: {
        minWidth: 80,
    },
    desc: {
        marginTop: 10,
    }
})

export default styles
